import React, { Component } from "react";
import { Container, Header, Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { APP_NAME } from "../../constants/resource.constants";
import { REGISTER_ROUTE, BASE_URL } from "../../constants/route.constants";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class AttractMorePlayersPage extends Component {
  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>3 tips to attract more players | {APP_NAME}</title>
            <meta
              name="description"
              content="This guide will help you attract more players by revealing 3 simple tips."
            />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta
              property="og:title"
              content={`3 tips to attract more players | ${APP_NAME}`}
            />
            <meta
              property="og:description"
              content="This guide will help you attract more players by revealing 3 simple tips."
            />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <Container text>
            <Header as="h1">3 Tips to Attract More Players</Header>
            <p>
              Are you looking to grow your club? Increase your clubs member
              count? Or trying to add more competition to an already ambitious
              group of players? Following these 3 easy steps will help you
              attract more players through <Link to="/">GAA International</Link>.
            </p>
            <Header as="h2">1) Followers</Header>
            <p>
              Followers are the best way to ensure your club is beating your
              rivals to new players. Firstly, having more followers means your
              club will appear closer to the top of the results. Being at the
              top will mean you{"'"}ll be seen by a lot more people, resulting
              in more views on your club page. Secondly, new players who sign up
              will see their friends who have also signed up. This means they
              will also see the current clubs their friends play for, and new
              players will generally tend to follow their friends at a new club.
            </p>
            <p>
              How to get followers? Easy. Ask your current players, members and
              fans to follow your club on your club page. Players who create
              their <Link to={REGISTER_ROUTE}>account</Link> and add your club
              to their history will automatically follow you. Your followers
              will get notifications about updates to your club and once we
              release Fixtures they won{"'"}t miss a game!
            </p>
            <Header as="h2">2) Is your location visible?</Header>
            <p>
              Searching via Maps is a feature currently in the works by the GAA
              International team. We{"'"}re hoping to get a couple more clubs to
              send through their training/match locations before we roll out
              this feature. We strongly believe searching via a map will become
              the default method players will find their new club. Don{"'"}t get
              left behind and send them through now. Do you have multiple
              locations? No problem. Send them all through and we will surface
              them on your club page.
            </p>
            <p>
              Is your club situated in a central area? Do you have the best
              training facilities? Don{"'"}t let a potential new player slip
              away because your location is not available. You are 5x more
              likely to hear from new players if they know exactly where you
              train.
            </p>
            <Header as="h2">3) Sell Your Club!</Header>
            <p>
              As they say in the tech world, "Content is King!". In this case,
              content is the information about your club. It helps to separate
              your club from every other one. Sell your club through your
              content is a great way to grab their attention. You don{"'"}t need
              to write an essay, but enough information to describe your club.
            </p>
            <p>
              Is your club striving to win back-to-back championships? Are you
              hoping to make the step from intermediate to senior? Or is your
              club about having fun, meeting new people and possibly having a
              few beverages together? Describe the culture of your club to
              attract the right people. If you{"'"}re still struggling to find
              the words, a very simple solution is to ask your members why they
              play with your club? What do they love about the club? Then you
              have the basis of your content.
            </p>
            <Header as="h3">Interested in managing your club page?</Header>
            <p>
              If you are, then great. We{"'"}d love to hand over the
              personalised of the page to you. Please send through your contact
              details, once we get enough interest we will prioritise this
              feature for all clubs.
            </p>
            <div className="spacer" />
            <Container textAlign="center">
              <Button
                as="a"
                size="huge"
                negative
                href="mailto:info@gaa.international?subject=Club-Info"
              >
                Send Your Club Info Now!
              </Button>
            </Container>
          </Container>
        </Container>
        <Footer />
      </div>
    );
  }
}

AttractMorePlayersPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/AttractMorePlayersPage/View.js